import { render } from "./DetailReward.vue?vue&type=template&id=05081dd7&scoped=true"
import script from "./DetailReward.vue?vue&type=script&lang=js"
export * from "./DetailReward.vue?vue&type=script&lang=js"

import "./DetailReward.vue?vue&type=style&index=0&id=05081dd7&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05081dd7"]])

export default __exports__